module.exports = __webpack_public_path__ + "img/425.efe39156.jpg";